/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   detail entity meta reducer
 */

import { falseReducer, nullReducer, payloadKeyReducer, trueReducer } from '@zcode/reducers'
import type { EntityMeta } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import {
  CANCEL_FETCHING_ENTITY,
  CLEAR_ENTITY,
  DONE_FETCHING_ENTITY,
  ERROR_FETCHING_ENTITY,
  START_FETCHING_ENTITY,
} from '../constants/index'
import type { ActionTypes } from './types'

export const meta = combineReducers<EntityMeta, ActionTypes>({
  error: handleActions<EntityMeta['error'], ActionTypes>(
    {
      [ERROR_FETCHING_ENTITY]: payloadKeyReducer('error'),
      [CLEAR_ENTITY]: nullReducer,
      [START_FETCHING_ENTITY]: nullReducer,
    },
    null
  ),
  fetching: handleActions(
    {
      [START_FETCHING_ENTITY]: trueReducer,
      [CLEAR_ENTITY]: falseReducer,
      [DONE_FETCHING_ENTITY]: falseReducer,
    },
    false
  ),
  fetchingKey: handleActions<EntityMeta['fetchingKey'], ActionTypes>(
    {
      [START_FETCHING_ENTITY]: payloadKeyReducer('key'),
      [CANCEL_FETCHING_ENTITY]: nullReducer,
      [CLEAR_ENTITY]: nullReducer,
      [DONE_FETCHING_ENTITY]: nullReducer,
    },
    null
  ),
})
